import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/access-codes/export-qr-codes`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportQrCodes = {
  post: apiPathFunc(pathBase),
} as const;
